import React from 'react'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import itLocale from 'date-fns/locale/it'

function FormDateVisibili({ handleChange, values, errors, touched, setFieldValue, isModifica }) {
  return (
    <div className={isModifica ? 'admin-container-lungo' : 'admin-container'}>
      <h3 className="admin-titoletto">Date Visibilità</h3>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={itLocale}>
        <Stack direction="row" spacing={7} paddingBottom={3} paddingTop={2}>
          <DatePicker
            label="Data Inizio"
            value={values.data_visibile_inizio}
            onChange={(value) => setFieldValue('data_visibile_inizio', value)}
            renderInput={(params) => <TextField {...params} />}
            mask="__/__/____"
          />
          <DatePicker
            label="Data Fine"
            value={values.data_visibile_fine}
            onChange={(value) => setFieldValue('data_visibile_fine', value)}
            renderInput={(params) => <TextField {...params} />}
            mask="__/__/____"
          />
        </Stack>
      </LocalizationProvider>
    </div>
  )
}

export default FormDateVisibili
